/**
 * PO metadata edits made outside the Incoming Stock card (Rhys 2026-10-28).
 *
 * Incoming Stock keeps a client copy of each PO list page (App.js
 * poResponseCacheRef + localStorage). A page fetched under a minute ago is
 * reused when the module reopens, and tab switches reuse pages for 15 min.
 * An ETA, confirm or tracking edit that does not drop that copy shows the old
 * value again after a trip to another module. The CEO tab writes the same PO
 * fields, so it announces each saved edit with this window event and App.js
 * drops the copy and patches the cards.
 */
export const PO_METADATA_CHANGED_EVENT = 'po:metadata-changed';

/** detail = { poId: '<id>', patch: { expectedArrivalDate | arrivalConfirmed | trackingLinks } } */
export function notifyPoMetadataChanged(poId, patch = {}) {
  if (poId == null || poId === '') return;
  try {
    window.dispatchEvent(new CustomEvent(PO_METADATA_CHANGED_EVENT, {
      detail: { poId: String(poId), patch: { ...patch } }
    }));
  } catch (_e) { /* no window */ }
}

/**
 * Optimistic metadata entry for one PO: the patch on top of any optimistic
 * metadata still live (a status move a moment earlier keeps its status),
 * stamped `updatedAt` so an older server copy (60 s server query cache, other
 * instances) loses to it in mergePOWithOptimisticMetadata while a newer one
 * wins. Pass `liveMetadata` from getRecentOptimisticPOMetadata, never an
 * expired entry.
 */
export function buildOptimisticPoMetadataEntry(liveMetadata, patch, now = Date.now()) {
  return {
    savedAt: now,
    metadata: {
      ...(liveMetadata || {}),
      ...patch,
      updatedAt: new Date(now).toISOString()
    }
  };
}
